﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederIasDto from '../Models/VeilederIasDto';

const borSammen = 'a1-borSammen';
const borIkkeSammen = 'a2-borIkkeSammen';
const enForelder = 'a3-enForelder';
const fosterhjemBarnevern = 'a4-fosterhjemBarnevern';

const aValg: RadioButtonValgModel<VeilederIasDto>[] = [
    {
        id: 'a1',
        value: borSammen,
        tekst: 'valgFamiliesituasjonForeldreBorSammen',
    },
    {
        id: 'a2',
        value: borIkkeSammen,
        tekst: 'valgFamiliesituasjonForeldreBorIkkeSammen',
    },
    {
        id: 'a3',
        value: enForelder,
        tekst: 'valgFamiliesituasjonEnForelder',
    },
    {
        id: 'a4',
        value: fosterhjemBarnevern,
        tekst: 'valgFamiliesituasjonFosterhjemBarnevern',
    },
];

export default {
    a1_borSammen: borSammen,
    a2_borIkkeSammen: borIkkeSammen,
    a3_enForelder: enForelder,
    a4_fosterhjemBarnevern: fosterhjemBarnevern,
    aValg,
};
